import React from "react"
import { styled } from "themes"
import { Select } from "antd"

export const StyledSelect = styled((props: any) => <Select {...props} />)``

export const StyledOption = styled((props: any) => (
  <Select.Option {...props} />
))``
